export const ptTranslation = {
  // Common
  common: {
    back: "Voltar"
  },
  learn: "Aprenda",
  market: "Mercado",
  analysis: "Análises",
  helpCenter: "Help Center",
  homePage: "Página Inicial",
  moreContentOnTheMedias: "Mais conteúdos nas redes:",
  articlesThatWillInterest: "Artigos que vão te interessar:",
  seeMore: "Ver mais",
  seeAll: "Ver tudo",
  loadMore: "Carregar Mais",
  noMoreResults: "Não há mais resultados",
  enterYourSearchHere: "Digite sua busca aqui...",
  theZeroFeeExchange: "A exchange *sem taxas.**",
  openYourAccount: "Abra sua conta",
  findHere: "Encontre Aqui",
  custodyInsurence: "Suas criptos seguras",
  yourAssetsProtected: "Temos custódia de criptomoedas pela #Fireblocks#, referência global em guarda de ativos.",
  fastTradingSpeeds: "Negociações mais rápidas sem cobrar nenhuma taxa.",
  apiDocumentation: "Documentação de API",
  allTradesBecomeRewards:
    "Todas os trades se tornam  recompensas em DGTA. E você ganha duas vezes: por número  de traders e volume negociado na plataforma na dia.",
  builtInAuthenticator: "Autenticador integrado",
  noMoreMultipleApps:
    "Nossa verificação de duas etapas é feita #diretamente no aplicativo#, tornando o acesso à sua conta mais fácil.",
  faceIdAsKey: "Selfie de segurança",
  youAreTheOnlyKey:
    "Usamos um sofisticado sistema biométrico. Você é a #única chave# para seu cofre.",
  exploreTheRevolution: "Explore a revolução.",
  getToKnowDigitra: "Conheça a digitra.com",
  allAroundTheWorld: "No mundo todo",
  digitraImpactsFinancial:
    "O Digitra.com impacta os mercados financeiros em todo o mundo e, é claro, está no coração de Wall Street.",
  learnMoreAboutDigitra: "Saiba mais sobre a Digitra",
  joinUs: "Entre na comunidade!",
  giveAwaysFirstHandNews:
    "Brindes, notícias em primeira mão, insights de mercado e dicas sobre nossos serviços.",
  connectWithTheCommunity:
    "Tudo sobre nossos produtos e serviços, diretamente com o time de especialistas.",
  lotsOfContentAboutUs:
    "Fale com a comunidade cripto, aprenda de um jeito simples, em tempo real com o mercado.",
  freshContenteMadeByOurExperts:
    "Acompanhe nossas novidades e acesse conteúdos educativos",
  weSpecializeInServing:
    "Somos especializados em atender clientes institucionais e cidadãos de alta renda que operam grandes ordens.",
  ourFocusIsOnProviding:
    "Nosso foco está em proporcionar uma experiência única e personalizada, adaptada às suas necessidades.",
  withOurOtcDesk:
    "Com o nosso OTC, espere serviços de execução e liquidação seguros, competitivos e confidenciais.",
  sendEmailTo: "Envie um e-mail para",
  withTheContactOfYourChoice:
    "com o contato de sua preferência (e-mail ou whatsapp) para receber ajuda de nosso especialista.",
  howOtcTradingCanUnleash:
    "Como as operações em OTC aumentam seu potencial financeiro?",
  itsSoSimple: "É tão simples!",
  ourClientsAcrossTheGlobe:
    "Nossos clientes em todo o mundo desfrutam de  liquidez incomparáveis.",
  withExclusiveNetworkRates:
    "Com taxas exclusivas de redes, eliminanos gastos desnecessários.",
  receiveSupportFromSpecialists:
    "Receba suporte de especialistas em todas as etapas da jornada.",
  talkToOneOfOurSpecialists: "Fale com um especialista hoje",
  stepByStep: "Nosso método",
  reachOutToUsNow: "Entre em contato",
  fillInTheFormToStart:
    "Preencha o formulário para iniciar nossa jornada juntos com um dos nossos especialistas.",
  insideTheAction: "Por dentro da ação",
  usingTheChannelOfYourChoice:
    "Usando o canal de sua escolha, você acompanhará a experiência do trading, com os spreads, taxas e fornecedores do mundo todo.",
  theFinishLine: "A linha de chegada",
  OurSkilledTrader:
    "Nossos traders habilidosos encontrarão o melhor preço - sempre - e assim que recebermos seus fundos, fechamos o negócio.",
  transparencyCompliance: "Transparência e Compliance",
  wellTransferTheDesiredAsset:
    "Transferimos o ativo para o endereço de sua carteira escolhida ou guardamos em sua conta aqui conosco, onde você tem seguro contra ataques.",
  createAccount: "Crie sua conta",
  digitraAuthenticator: "Autenticador Digitra.com",
  helpCenterPage: "Central de Ajuda",
  privacyCookie: "Política de Privacidade e Cookies",
  termsUse: "Termos de Uso",
  feesLimits: "Taxas e Limites",
  begginer: "iniciante",
  intermediate: "intermediário",
  advanced: "avançado",
  tradeToEarnExclusivity: "Exclusividade Trade to Earn!",
  pageNotFound: "Página não encontrada",
  zeroFeeWithDGTA: "* Para contas com, no mínimo, 2500 DGTAs de saldo disponível.",
  digitraApplicableLaw: "A Digitra.com está em conformidade com todas as leis e regulamentos aplicáveis no Brasil. Em atendimento ao disposto no art. 41 da Lei n° 13.709 de 2018 (Lei Geral da Proteção de Dados), a Digitra.com designa como encarregado pelo tratamento dos dados: Vanessa Rodrigues.",
  openAndEarn: "Abra sua conta e ganhe tokens *DGTA*",
  openMyAccount: "ABRIR MINHA CONTA!",
  globalExchange: "Corretora de #criptomoedas# presente em mais de 170 países",
  aboutDGTA: "Token ERC-20 nativo da digitra.com oferece recompensas diárias no programa #Trade to Earn#.",
  aboutTradeToEarn: "Ganhe cashback em DGTA por cada trade realizado, todos os dias. \n#Simples#: comprou ou vendeu alguma moeda, ganhou DGTA. Acumule tokens diariamente!",
  learnMore: "Saiba mais!",
  zeroFee: "*Taxa Zero*",
  zeroFeeExplanation: "Detentores do token DGTA garantem taxa zero em #todos os pares#.",
  api: "API",
  goToDocumentation: "Acessar documentação",
  apiText: "Negociações mais #rápidas# e automatizadas.",
  feePageTitle: "Política de Taxas da digitra.com",
  
  // Signup Flow
  signup: {
    // Etapa 1 - Email
    welcomeTitle: "Boas vindas à Digitra.com",
    welcomeSubtitle: "Crie sua conta e comece a negociar criptomoedas com segurança e confiança.",
    emailPlaceholder: "Digite seu e-mail",
    continueButton: "Continuar",
    termsText: "Ao continuar, você concorda com nossos",
    termsLink: "Termos de Uso",
    andText: "e",
    privacyLink: "Política de Privacidade",
    
    // Etapa 2 - Verificação de Email
    verifyEmailTitle: "Verifique seu e-mail",
    verifyEmailSubtitle: "Enviamos um código de 6 dígitos para",
    codePlaceholder: "000000",
    codeLabel: "Código de verificação",
    codeHelpText: "Digite os 6 dígitos do código enviado",
    continueWithCodeButton: "Continuar",
    verifyingText: "Verificando...",
    resendText: "Não recebeu o código?",
    resendButton: "Reenviar código",
    resendCountdown: "Reenviar em {{seconds}}s",
    codeExpiresText: "O código expira em 15 minutos por segurança",
    
    // Etapa 3 - Senha
    createPasswordTitle: "Crie sua senha",
    createPasswordSubtitle: "Escolha uma senha forte para proteger sua conta",
    passwordPlaceholder: "Digite sua senha",
    passwordLabel: "Senha",
    confirmPasswordPlaceholder: "Digite novamente sua senha",
    confirmPasswordLabel: "Confirme sua senha",
    passwordRequirementsTitle: "Requisitos da senha",
    passwordRequirements: {
      minLength: "Pelo menos 8 caracteres",
      uppercase: "Pelo menos uma letra maiúscula",
      lowercase: "Pelo menos uma letra minúscula",
      number: "Pelo menos um número",
      special: "Pelo menos um caractere especial"
    },
    passwordStrength: "Força da senha:",
    passwordStrengthLevels: {
      weak: "Fraca",
      medium: "Média",
      strong: "Forte"
    },
    passwordsMatch: "✓ Senhas coincidem",
    passwordsNotMatch: "✗ Senhas não coincidem",
    validatingText: "Validando...",
    
    // Etapa 4 - Código de Referral
    referralTitle: "Código de indicação",
    referralSubtitle: "Tem um código de indicação? Digite aqui. Caso contrário, pode pular esta etapa.",
    referralPlaceholder: "DIGITE O CÓDIGO",
    referralLabel: "Código de indicação (opcional)",
    referralHelpText: "Digite o código exatamente como foi fornecido",
    referralDetected: "🎯 Código de indicação detectado na URL:",
    referralPrefilled: "Código pré-preenchido da URL. Você pode editá-lo se necessário.",
    continueWithReferralButton: "Continuar com código",
    continueWithReferralUrlButton: "Continuar com código da URL",
    skipButton: "Pular esta etapa",
    referralBenefitsTitle: "💡 Por que usar um código de indicação?",
    referralBenefit1: "Ganhe mais tokens DGTA na abertura da conta.",
    referralBenefit2: "Receba até 100 DGTA sozinho.",
    referralBenefit3: "Para desbloquear seus tokens, faça transações que somem ao menos 5 dólares.",
    
    // Etapa 5 - Sucesso
    successTitle: "Conta criada com sucesso!",
    successSubtitle: "Parabéns! Sua conta na Digitra.com foi criada e está ativa.",
    nextStepsTitle: "🚀 Próximos passos",
    nextStep1: "Baixe o app Digitra.com no seu celular",
    nextStep2: "Faça login com seu e-mail e senha",
    nextStep3: "Complete seu cadastro",
    nextStep4: "Deposite com PIX ou traga suas criptos e ganhe recompensas no Staking",
    nextStep5: "Comece a negociar criptomoedas!",
    downloadAppStore: "Baixar na",
    downloadGooglePlay: "Baixar na",
    needHelpText: "Precisa de ajuda? Entre em contato conosco",
    emailSupport: "E-mail",
    telegramSupport: "Telegram",
    
    // Benefícios
    benefits: {
      staking: {
        title: "Staking",
        description: "Ganhe até 8,4% ao ano com seus ativos digitais"
      },
      security: {
        title: "Segurança Total",
        description: "Custódia institucional com Fireblocks"
      },
      rewards: {
        title: "Recompensas DGTA",
        description: "Ganhe tokens por cada trade realizado"
      }
    },
    
    // Mensagens de erro
    errors: {
      emailRequired: "E-mail é obrigatório",
      invalidEmail: "E-mail inválido",
      codeRequired: "Código é obrigatório",
      invalidCode: "Código inválido",
      passwordRequired: "Senha é obrigatória",
      weakPassword: "Senha muito fraca",
      passwordsNotMatch: "Senhas não coincidem",
      serverError: "Erro no servidor. Tente novamente.",
      networkError: "Erro de conexão. Verifique sua internet.",
      unknownError: "Erro desconhecido. Tente novamente.",
      genericError: "Erro ao processar solicitação. Tente novamente.",
      
      // Erros HTTP específicos
      validationError: "Erro de validação",
      unauthorized: "Não autorizado",
      forbidden: "Acesso negado",
      notFound: "Recurso não encontrado",
      tooManyRequests: "Muitas tentativas",
      internalServerError: "Erro interno do servidor",
      
      // Mensagens específicas
      invalidData: "Dados inválidos enviados",
      sessionExpired: "Sessão expirada ou não autorizada",
      noPermission: "Você não tem permissão para realizar esta ação",
      resourceNotFound: "O recurso solicitado não foi encontrado",
      rateLimitExceeded: "Muitas tentativas. Aguarde um momento e tente novamente",
      serverUnavailable: "Erro no servidor. Tente novamente em alguns minutos",
      emptyResponse: "O servidor retornou uma resposta vazia",
      invalidEndpoint: "Configuração da API inválida",
      connectionFailed: "Verifique sua conexão com a internet e tente novamente",
      requestConfigError: "Erro na configuração da requisição",
      unexpectedError: "Erro inesperado. Tente novamente"
    },
    
    // Mensagens de sucesso
    success: {
      emailSent: "E-mail enviado com sucesso! Verifique sua caixa de entrada."
    }
  },
  tradeFeeSubtitle: "Taxa de negociação",
  withdrawFeeSubtitle: "Taxa de saque",
  withdrawFeeParagraph: "A digitra.com não cobra taxas em saques de moedas fiat, como o Real brasileiro, somente em saques de criptomoedas, cobradas quando você quiser retirar uma criptomoeda da digitra.com, podendo transferir para outra exchange ou wallet de cripto.",
  howDoesItWork: "Como funciona?",
  withdrawFeeExplanation: "A taxa de saque se refere à taxa da rede blockchain e a serviços operacionais. A taxa de rede *varia de acordo com a blockchain* usada para a transferência. A taxa de serviço corresponde a *20% sobre o valor da taxa de rede*, ou seja, o valor também dependerá da rede que você escolher para sacar.",
  withdrawFeeImportant: "*Importante:* para todas as criptomoedas, a taxa mínima de saque é de *$1*. Veja os exemplos abaixo:",
  tradeFeeWithoutMinDGTA: "A taxa em transações de compra ou venda com qualquer par de ativos disponíveis na digitra.com é de 0,1% para market maker e 0,5% para market taker. A cobrança de taxa nesse caso será a seguinte:",
  tradeFeeWithoutMinBullet: "*0,1% ou 0,5% sob o volume negociado na transação — valor cobrado em cima da moeda que será creditada em sua conta*",
  tradeFeeExample: "*Ex:* Se você tiver um saldo de 10 dólares e usá-lo para comprar Bitcoin, a taxa será cobrada em cima do crédito em Bitcoin. Assim que a compra for concluída, o seu saldo de Bitcoin já estará na carteira com o valor da taxa descontado.",
  examples: "Exemplos",
  crypto: "Criptomoeda",
  blockchainFee: "Taxa de rede",
  totalFee: "Taxa total",
  cryptoCase1: "Você está sacando Ethereum ETH, usando a rede ERC-20",
  cryptoCase2: "Você está sacando MATIC na rede Polygon",
  blockchainFeeCase1: "A taxa de rede no momento do saque está em 0.003253 ETH, equivalente a $7",
  blockchainFeeCase2: "A taxa de rede no momento do saque está em 0.567774 MATIC, equivalente a $0,50",
  totalFeeCase1: "A taxa total irá incluir os 20% de serviço referente a taxa de rede, totalizando $8,4",
  totalFeeCase2: "A taxa total ficará no valor mínimo de $1",
  minDGTAZeroFeeLink: "200 DGTA tokens",
  seeMoreAbountTradeFee: "Veja aqui mais detalhes da Taxa Zero em negociações!",
  tradingFeeWithMinDGTAStart: "Os clientes que mantém, no mínimo,",
  inYourWallet: ", em sua carteira digitra.com não pagam taxas de negociação à vista.",
  fees: "Taxas",
  makerAndTaker: "O que é Market Maker e Market Taker?",
  makerAndTakerResume: "No contexto do mercado de criptomoedas, os termos *\"maker\"* e *\"taker\"* referem-se a dois participantes distintos no processo de negociação. O market maker, ou criador de mercado, é aquele que coloca as ordens a limite, definindo previamente os valores dos ativos para compra ou venda. Sua função é criar liquidez no mercado, disponibilizando ordens que aguardam correspondência. Por outro lado, o market taker, ou tomador de mercado, é quem aceita as ordens previamente estabelecidas pelo market maker. O papel do taker é executar ordens de mercado, atendendo às solicitações de compra ou venda com base nos preços atuais do ativo.",
  makerAndTakerOrderTypes: "Para compreender melhor esses papéis, é necessário compreender as diferenças entre ordens de mercado e ordens a limite. As ordens de mercado são executadas com base nos preços atuais do ativo, enquanto as ordens a limite têm seus valores pré-estabelecidos pelo comprador ou vendedor. Portanto, o market maker é o responsável por criar ordens a limite, contribuindo para a formação da livro de ofertas de criptomoedas, enquanto o market taker utiliza ordens de mercado para realizar transações. Essa distinção não apenas influencia o processo de negociação, mas também impacta as taxas cobradas pelos serviços, destacando a importância desses dois participantes no ecossistema das criptomoedas.",
  cryptoDividends: "Dividendos Cripto",
  cryptoDividendsText: "Seu saldo gera rendimentos todo mês, pagos em tokens DGTA.",
  openAccount: "Abrir conta",
  liquidityProvider: "Provedor de Liquidez",
  liquidityProviderText: "Suas ordens de compra ou venda de criptomoedas geram rendimentos.",
  readLitePaper: "Leia o Litepaper!",
  liquidityLitepaper: "Litepaper Provedor de Liquidez",
  simpleSecurePlatform: "Plataforma simplificada e segura",
  earnCrypto: "Ganhe criptomoedas",
  tokenDgta: "Token DGTA",
  tokenDgtaText: "DGTA é o nosso token, distribuído em programas de recompensa na plataforma e usado para recompensar nossos clientes.",
  blockchain: "Blockchain",
  blockchainText: "DGTA é um #token ERC-20# da #rede Ethereum#",
  supply: "Supply Máximo",
  supplyText: "300 milhões de unidades",
  burnPolicy: "Política de queima",
  burnPolicyText: "50% do supply máximo #será queimado#",
  listing: "Listagem",
  listingText: "Listado na #Digitra.com# com pares #BRL# e #USDT#",
  buyBtcEthAndMore: "Compre Bitcoin e mais de 40 criptomoedas com até #8,4%# ao ano de #recompensa#",
  exchangeThatPaysToUse: "A Digitra.com é uma corretora de criptomoedas global que recompensa você por abrir conta, depositar, negociar e manter saldo em cripto",
  start: "Começar",
  startNowEarnDgta: "Abra sua conta e ganhe criptomoedas para começar!",
  newAccount: "Bônus na abertura de conta",
  newAccountText: "Ganhe tokens DGTA assim que completar seu cadastro.",
  referralProgram: "Programa de Indicação",
  referralProgramText: "Indique a Digitra.com e ganhe tokens DGTA de recompensa.",
  tradeEarn: "Trade to Earn",
  tradeEarnText: "Com apenas um trade você ganha sua parte no AirDrop diário de 5 mil tokens DGTA.",
  tradersLeague: "Traders League",
  tradersLeagueText: "Receba recompensas diárias por negociar criptomoedas.",
  iWantToEarn: "Quero ganhar!",
  staking: "Staking",
  stakingText: "Seu saldo gera até 8,4% de #recompensa# ao ano, pagas em tokens DGTA."
}